import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApi } from "@/lib/useApi";
import { MaterialIcon } from "@/components/MaterialIcon";
import { ImageUpload } from "@/components/admin/ImageUpload";
import { PageTitle, btnPrimary, btnSmall, card, inputCls } from "@/components/admin/ui";

const Row = ({ s, onUpdate, onDelete }) => {
  const [name, setName] = useState(s.name);
  const commit = () => {
    if (name.trim() && name !== s.name) onUpdate(s.id, { name: name.trim() });
    else setName(s.name);
  };
  return (
    <div className="flex flex-wrap items-center gap-4 p-3" data-testid={`style-row-${s.id}`}>
      <ImageUpload value={s.image_url} onChange={(url) => onUpdate(s.id, { image_url: url })} aspect="2 / 1" hint="Tile image" className="w-[120px] shrink-0" testId={`style-image-${s.id}`} />
      <div className="min-w-[180px] flex-1">
        <input value={name} onChange={(e) => setName(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} className={`${inputCls} h-9 max-w-[320px]`} data-testid="style-name-input" />
        <p className="mt-1 text-[12px] text-[#6B7280]">/styles/{s.slug}</p>
      </div>
      <button type="button" className={`${btnSmall} text-[#B91C1C] border-[#FECACA] hover:bg-[#FEF2F2]`} onClick={() => onDelete(s)} data-testid="style-delete">Delete</button>
    </div>
  );
};

export default function AdminDanceStyles() {
  const { data: styles, reload } = useApi("/admin/dance-styles");
  const [name, setName] = useState("");

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/admin/dance-styles", { name });
      setName("");
      reload();
      toast.success("Dance style added");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const update = async (id, patch) => {
    try {
      await api.put(`/admin/dance-styles/${id}`, patch);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const del = async (s) => {
    if (!window.confirm(`Delete dance style “${s.name}”? It will be removed from all videos and festivals.`)) return;
    try {
      await api.delete(`/admin/dance-styles/${s.id}`);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div data-testid="admin-dance-styles-page">
      <PageTitle title="Dance Styles" />
      <p className="text-[13px] text-[#6B7280] -mt-3 mb-5">Dance styles power “Browse by dance style”, the search panel tiles, and the tags on videos and festivals.</p>
      <form onSubmit={add} className="flex gap-2 mb-5">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="New dance style, e.g. Lindy Hop" className={inputCls} data-testid="style-name-new-input" />
        <button type="submit" className={`${btnPrimary} shrink-0`} disabled={!name.trim()} data-testid="style-add-button">
          <MaterialIcon name="add" size={20} weight={600} />
          Add
        </button>
      </form>
      <div className={`${card} divide-y divide-[#E5E7EB]`} data-testid="style-list">
        {styles?.map((s) => <Row key={s.id} s={s} onUpdate={update} onDelete={del} />)}
        {styles && styles.length === 0 && <p className="p-8 text-center text-[14px] text-[#6B7280]">No dance styles yet.</p>}
      </div>
    </div>
  );
}
